import { BookingAddressPicker } from '@components/Address/BookingAddressPicker';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { t } from '@lingui/core/macro';
import { noddiToast } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useNavigate } from 'react-router-dom';
import { useMobileBookingCustomer } from '../../../hooks/useMobileBookingCustomer';
import { useTrackProposalStep } from '../../../hooks/useTrackProposalStep';
import { useBookingProposalActions, useBookingProposalSlug } from '../../../stores/bookingProposalStore';

export const ProposalEditAddressPicker = () => {
  const { setAddress } = useBookingProposalActions();
  const { userGroupId } = useMobileBookingCustomer();
  const navigate = useNavigate();
  const slug = useBookingProposalSlug();
  useTrackProposalStep('editAddress');

  return (
    <ContentWrapperCustomerApp className='max-w-screen-md' title={t`Where do you need our help?`}>
      <BookingAddressPicker
        userGroupId={userGroupId}
        setSelectedAddress={(newAddress) => {
          // address is not in delivery area (or some error occurred), so we do nothing
          if (!newAddress) {
            return;
          }
          setAddress(newAddress);
          // give feedback on successful address selection on landing page as we auto navigate, as normally it says we deliver here
          noddiToast.success(t`Address has been successfully changed`);
          // if old address exists determines if we go back to landing page or to time window picker
          navigate(customerRoutes.bookingProposalLandingPage.getPath({ slug }));
        }}
      />
    </ContentWrapperCustomerApp>
  );
};
